import React, { useEffect } from 'react';
import './App.css';
import HomeScreen from './screens//HomeScreen';
import { Routes, Route } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import { auth } from './firebase';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, selectUser } from './features/userSlice';
import ProfileScreen from './screens/ProfileScreen';

//NB:- whenever we are using a useEffect we should have a cleanup function //
function App() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
   
  // the following useEffect listens to the users logged in state. onAuthStateChanged is a listener//

  useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((userAuth) => {
        if (userAuth) {
            //Logged in
            dispatch(login({
              uid: userAuth.uid,
              email: userAuth.email,
            }))
        } else {
            //Logged out
            dispatch(logout())
        }
      });
      // if the component was ever to unmount we dont want to duplicate another listener, we just wnat to detach the old one and attach a new one //
      return unsubscribe;

  }, [dispatch]);
  
  return (
    <div className="app">
        {!user ? (
          <LoginScreen />
        ) : (
          <Routes>
            <Route path="/profile" element={<ProfileScreen />} />
            <Route exact path='/' element={<HomeScreen />} />
        </Routes>
        )}   
    </div>
  );
}

export default App;
